import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useEditorSettings } from "../../contexts/EditorSettings";

function BalanceCheckerEditorSettings() {
  // Contexts
  const { t: translate } = useTranslation();
  const { settings, saveSettings, resetSettings } = useEditorSettings();

  // Functions
  const handleSelectError = (event) => {
    const { value, checked } = event.target;

    saveSettings({
      ...settings,
      errors: checked
        ? [...settings.errors, value]
        : settings.errors.filter((error) => error !== value),
    });
  };

  const handleSelectVerification = (event) => {
    saveSettings({
      ...settings,
      showVerificationCode: event.target.checked,
    });
  };

  const handleSelectCaptcha = (event) => {
    saveSettings({
      ...settings,
      showCaptcha: event.target.checked,
    });
  };

  // CONSTANTS
  const errorOptions = [
    {
      label: translate("errors.invalidCardNumber"),
      value: "invalidCardNumber",
      checked: settings.errors.includes("invalidCardNumber"),
      onChange: handleSelectError,
    },
    {
      label: translate("errors.missingCardNumber"),
      value: "missingCardNumber",
      checked: settings.errors.includes("missingCardNumber"),
      onChange: handleSelectError,
    },
    {
      label: translate("errors.cardNumberRequired"),
      value: "cardNumberRequired",
      checked: settings.errors.includes("cardNumberRequired"),
      onChange: handleSelectError,
    },
  ];

  const verificationOptions = [
    {
      label: "Verification Code",
      value: "verificationCode",
      checked: settings.showVerificationCode,
      onChange: handleSelectVerification,
    },
    {
      label: "Captcha",
      value: "captcha",
      checked: settings.showCaptcha,
      onChange: handleSelectCaptcha,
    },
  ];

  // RENDER
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ py: 1, px: 2, backgroundColor: "action.selected" }}
    >
      {/* SECURITY */}
      <Stack>
        <FormLabel component="legend">Verifications</FormLabel>

        <FormGroup row>
          {verificationOptions.map((option) => {
            return (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    key={option.value}
                    checked={option.checked}
                    value={option.value}
                    onChange={option.onChange}
                    size="small"
                  />
                }
                label={option.label}
              />
            );
          })}
        </FormGroup>
      </Stack>

      <Divider orientation="vertical" flexItem />

      {/* ERRORS */}
      <Stack>
        <FormLabel component="legend">Errors</FormLabel>

        <FormGroup row>
          {errorOptions.map((option) => {
            return (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    key={option.value}
                    checked={option.checked}
                    value={option.value}
                    onChange={option.onChange}
                    size="small"
                  />
                }
                label={option.label}
              />
            );
          })}
        </FormGroup>
      </Stack>

      <Divider orientation="vertical" flexItem sx={{ flexGrow: 1 }} />

      {/* RESET SETTINGS */}
      <Tooltip title="Reset settings">
        <IconButton onClick={resetSettings}>
          <ManageHistoryIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}

export default BalanceCheckerEditorSettings;
